import { Fragment, useEffect, useState } from "react";
import { toast } from "sonner";
import { listGhlNoshowRuns } from "@/lib/api";
import { Empty, TH, TR, errMsg } from "@/components/accounts/shared";

// End-of-day auto no-shows in GoHighLevel (CR-0050), read-only. Each gym's consult appointments that day
// nobody marked showed (or cancelled) are marked no-show around 22:30 gym time. GHL_AUTO_NOSHOW: off / dry / on.
const MODE = {
  off: "Off: nothing runs",
  dry: "Dry run: lists what it would mark, changes nothing in GoHighLevel",
  on: "On: marks no-shows in GoHighLevel",
};
const ACTION = { marked: "Marked no-show", would_mark: "Would mark", skipped: "Skipped", failed: "Failed" };

export default function GhlNoshowRuns() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState("");
  useEffect(() => {
    listGhlNoshowRuns({ limit: 60 }).then(setData).catch((e) => { toast.error(errMsg(e, "Could not load")); setData({ runs: [] }); });
  }, []);
  if (!data) return <Empty>Loading…</Empty>;
  return (
    <div className="space-y-4" data-testid="ghl-noshow-runs">
      <p className="text-sm text-zinc-400 max-w-3xl">
        Every evening (22:30 gym time) each gym&apos;s consult appointments that nobody marked showed or cancelled are
        marked no-show in GoHighLevel, so its no-show follow-up runs. People FPA saw come in (questionnaire, consult
        saved) are skipped. Mode: <span className="text-zinc-200">{MODE[data.mode] || data.mode}</span>
        {Array.isArray(data.gyms) && <> · gyms: {data.gyms.join(", ")}</>}
      </p>
      {!data.runs.length ? <Empty>No runs yet.</Empty> : (
        <div className="card-surface overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr>
              {["Day", "Gym", "Mode", "Marked", "Would mark", "Skipped", "Failed", "Notes"].map((h) => <th key={h} className={`${TH} px-3 py-2`}>{h}</th>)}
            </tr></thead>
            <tbody>
              {data.runs.map((r) => (
                <Fragment key={r.id}>
                  <tr className={`${TR} cursor-pointer`} onClick={() => setOpen(open === r.id ? "" : r.id)}>
                    <td className="px-3 py-2 whitespace-nowrap">{r.day}</td>
                    <td className="px-3 py-2">{r.gym}</td>
                    <td className="px-3 py-2">{r.mode}{r.trigger === "manual" ? ` (by ${r.by || "admin"})` : ""}</td>
                    <td className="px-3 py-2">{r.counts?.marked || 0}</td>
                    <td className="px-3 py-2">{r.counts?.would_mark || 0}</td>
                    <td className="px-3 py-2">{r.counts?.came_in || 0}</td>
                    <td className="px-3 py-2">{r.counts?.failed || 0}</td>
                    <td className="px-3 py-2 text-xs text-rose-300">{r.error || ""}</td>
                  </tr>
                  {open === r.id && (
                    <tr><td colSpan={8} className="px-3 py-2 bg-[#0c0c0c]">
                      {!r.items?.length ? <span className="text-xs text-zinc-500">Nothing to mark.</span> : (
                        <ul className="text-xs text-zinc-300 space-y-1">
                          {r.items.map((i) => (
                            <li key={i.event_id}>
                              {(i.start || "").slice(11, 16)} · {i.name} · {i.calendar} · was {i.old_status} → {ACTION[i.action] || i.action}
                              {i.reason ? <span className="text-zinc-500"> ({i.reason})</span> : null}
                            </li>
                          ))}
                        </ul>
                      )}
                    </td></tr>
                  )}
                </Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
